module.exports = __webpack_public_path__ + "static/media/view6.b28c0b42.jpg";